import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "next/image";
import { z } from "zod";
import { generateImageLoader } from "@cinch-nx/data-storyblok";
import styles from "./author.module.css";
import { getDayMonthYearFormat } from "@cinch-labs/shared-util";
var imageSchema = z.object({
    filename: z.string(),
    alt: z.string().optional()
});
export function Author(param) {
    var latestPublishDate = param.latestPublishDate, name = param.name, image = param.image;
    var actualImage = imageSchema.safeParse(image);
    var _alt;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.author,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.border,
                children: actualImage.success ? /*#__PURE__*/ _jsx(Image, {
                    src: actualImage.data.filename,
                    alt: (_alt = actualImage.data.alt) !== null && _alt !== void 0 ? _alt : "An Image of the author",
                    width: 210,
                    height: 210,
                    loader: generateImageLoader({
                        height: 210,
                        widthOverride: 210,
                        useSmartCrop: true
                    })
                }) : /*#__PURE__*/ _jsx("img", {
                    src: "/images/author-fallback.png",
                    alt: "Cinch logo"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.textContainer,
                children: /*#__PURE__*/ _jsxs("p", {
                    children: [
                        "By ",
                        name || "cinch",
                        /*#__PURE__*/ _jsx("span", {
                            className: styles.breakline,
                            "aria-hidden": true,
                            children: "|"
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: styles.updatedOn,
                            children: [
                                "Updated on ",
                                getDayMonthYearFormat(latestPublishDate)
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
export default Author;
